class ScrollToService {
    /*@ngInject*/
    constructor() {
        this.scrollTo = function(anchor, offset) {
            var element = angular.element(anchor);
            angular.element(document.querySelector('.fixed')).addClass('animate-fixed');
            angular.element('body,html').animate({scrollTop: element.offset().top - offset}, "slow");
            angular.element(document.querySelector('.animate-fixed')).removeClass('animate-fixed');
        }
    }
}

export default ScrollToService;


// WEBPACK FOOTER //
// ./src/app/services/scroll-to-service.js